import request from "@/utils/request"

/**
 *
 * @returns {Object} fetched users response object
 */
export function fetchUsers(params = {}) {
  return request({
    url: "/api/users",
    method: "get",
    params
  })
}

/**
 * @param {Number} id - id to fetch user with
 * @returns {Object} fetched user response object
 */
export function fetchSingleUser(id) {
  return request({
    url: "/api/users/" + id,
    method: "get"
  })
}

/**
 *
 * creates a new user
 * @param {Object} params - request params
 * @param {Object} params - request params
 * @returns {Object} created user response object
 */
export function createUser(params, data) {
  return request({
    url: "/api/users",
    method: "post",
    params,
    data
  })
}

/**
 *
 * updates a user
 * @param {Object} id - user id to update
 * @param {Object} params - request params
 * @param {Object} data - request data
 * @returns {Object} created user response object
 */
export function updateUser(id, params, data = new FormData()) {
  return request({
    url: "/api/users/" + id,
    method: "post",
    params,
    data,
    headers: {
      "Content-Type": "multipart/form-data"
    }
  })
}

/**
 *
 * deletes user from database
 * @param {Object} id - user id to delete
 * @returns {Object} created user response object
 */
export function deleteUser(id) {
  return request({
    url: "/api/users/" + id,
    method: "delete"
  })
}

export function updateAccount({ params = {}, data = new FormData() }) {
  return request({
    url: "/api/account",
    method: "post",
    data,
    params,
    headers: {
      "Content-Type": "multipart/form-data"
    }
  })
}

export function downloadOwnRib() {
  return request({
    url: "/api/users/downloadOwnRib",
    method: "get",
    responseType: "blob"
  })
}

export function downloadUserRib(id) {
  return request({
    url: "/api/users/downloadUserRib/" + id,
    method: "get",
    responseType: "blob"
  })
}

/**
 *
 * contact us
 * @param {Object} params - request params
 * @param {Object} data - request params
 * @returns {Object} created user response object
 */
export function contactUs(params, data) {
  return request({
    url: "/api/users/contactUs",
    method: "post",
    params,
    data
  })
}

/**
 *
 * @returns {Object} fetched annonceurs response object
 */
export function fetchAnnonceurs(params = {}) {
  return request({
    url: "/api/users/annonceur",
    method: "get",
    params
  })
}

/**
 *
 * @returns {Object}
 */
export function toggleAdminAccess(id, params = {}) {
  return request({
    url: "/api/user/" + id + "/admin/access",
    method: "post",
    params
  })
}

/**
 *
 * Creates inexisting user plannings
 * @param {Object} user - request user id
 * @returns {Object} created user response object
 */
export function createInexistingPlannings(user) {
  return request({
    url: `/api/user/${user}/plannings/createinexisting`,
    method: "post"
  })
}
/**
 *
 * @returns {Object} fetched pharmacists response object
 */
export function fetchPharmacists(params = {}) {
  return request({
    url: "/api/users/pharmacist",
    method: "get",
    params
  })
}

/**
 * @returns {Object} searched pharmacists response object
 */
export function searchPharmacists(params = {}) {
  return request({
    url: "/api/users/pharmacist/search",
    method: "get",
    params
  })
}

/**
 * @returns {Object} available pharmacists response object
 */
export function getAvailablePharmacists(params = {}) {
  return request({
    url: "/api/users/available/campaign",
    method: "get",
    params
  })
}

/**
 * @param {Number} UserId receives user's id to get it's requests
 *
 * @returns {Object} Available campaign requests
 */
export function getUserCampaignRequests(user) {
  return request({
    url: `/api/user/${user}/campaign/request`,
    method: "get"
  })
}

/**
 *
 * @param  {Object} params - contains the year to get plannings for, and the user id!
 * @returns {Object} fetched planning history response object
 */
export function fetchPlanningsHistory(params) {
  return request({
    url: "/api/users/plannings/history",
    method: "get",
    params
  })
}

export function getGroupements() {
  return request({
    url: "/api/users/groupements",
    method: "get"
  })
}

export function getVilles() {
  return request({
    url: "/api/users/villes",
    method: "get"
  })
}
